package pl.mothdigital.neuronowi.theme.palette

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

object WhitePalette : ColorPalette {
    private val whiteColor = Color.rgb(0xFFFFFF)

    override val _50: Color
        get() = whiteColor.copy(alpha = 25)
    override val _100: Color
        get() = whiteColor.copy(alpha = 50)
    override val _200: Color
        get() = whiteColor.copy(alpha = 75)
    override val _300: Color
        get() = whiteColor.copy(alpha = 100)
    override val _400: Color
        get() = whiteColor.copy(alpha = 125)
    override val _500: Color
        get() = whiteColor.copy(alpha = 150)
    override val _600: Color
        get() = whiteColor.copy(alpha = 175)
    override val _700: Color
        get() = whiteColor.copy(alpha = 200)
    override val _800: Color
        get() = whiteColor.copy(alpha = 225)
    override val _900: Color
        get() = whiteColor.copy(alpha = 255)
}

